import React from "react";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";

export interface Props {
    navigation: any,
    buttonStyle?: React.CSSProperties
}

const EasyLangToggleButton = (props: Props) => {
    const {t} = useTranslation();
    const navigationRoot = props?.navigation?.content?.site?.root;
    const button = navigationRoot?.easyLangToggleButton;
    const buttonLabel = navigationRoot?.easyLangToggleLabel?.easyLangToggleButtonLabel ?? t('easy_language_toggle_button_label');
    const active = navigationRoot?.easyLangToggleActive?.easyLangToggleButtonActive ?? false;
    if (!button) {
        return null;
    }
    const href = button?.selfUrl;

    return (button && href
            ? <Button component={Link}
                      data-cypress={'easyLangToggleButtonLink'}
                      id={"easy-lang-toggle-button"}
                      href={href}
                      prefetch={false}
                      variant="text"
                      fullWidth={false}>
                    <Box component="img"
                         src="/aufgeschlagenes-buch.svg"
                         alt=""
                         sx={{width: '24px', height: '24px'}}/>
                    <Typography variant='ctaButton'
                                sx={{
                                    lineHeight: "16px",
                                    marginY: "5px",
                                    marginLeft: "10px",
                                    marginRight: "10px",
                                    textDecoration: active ? 'underline' : 'none',
                                    textDecorationThickness: active ? '2px' : 'initial',
                                    textUnderlineOffset: active ? '4px' : 'initial'
                                }}>{buttonLabel}</Typography>
            </Button>
            : null
    );
}
export default React.memo(EasyLangToggleButton);
